import { Component as ReactComponent, ComponentType } from 'react';
import { PresetService } from '../../auth/services/PresetService';
import { PageLoader } from '../components/PageLoader';
import { AppConfigContext } from '../services/AppConfigContext';

type WithAppConfigProps = {};

type WithAppConfigState = {
  loaded: boolean;
};

export const withAppConfig = (Component: ComponentType) => {
  return class extends ReactComponent<WithAppConfigProps, WithAppConfigState> {
    private readonly presetsService = new PresetService();

    constructor(props: WithAppConfigProps, context: unknown) {
      super(props, context);

      this.state = { loaded: false };
    }

    componentDidMount() {
      this.init();
    }

    componentWillUnmount() {
      this.presetsService.cancelAllRequests();
    }

    async init() {
      try {
        const presets = await this.presetsService.getPresets();

        AppConfigContext.setPresets(presets);

        this.setState({ loaded: true });
      } catch (e: unknown) {
        this.setState(() => {
          // Force the error to go through `ErrorBoundary`
          throw e;
        });
      }
    }

    render() {
      if (!this.state.loaded) {
        return <PageLoader />;
      }
      return <Component {...this.props} />;
    }
  };
};
